import React, { memo } from 'react';
import PropTypes from 'prop-types';
import { Row, Col } from 'react-bootstrap';
import Avatar from '@components/@core/Avatar';
import Button from '@components/@core/AnimatedButton';
import Rating from '@components/@core/Rating';
import { convertUrl, removeTags } from '~/services/util';

const ProductItem = ({ logo, name, description, companyName, recommend, rating, ratingCount, phone, type, url, onClick, isSponsored }) => {
    return (
        <div className={`vendor-search-product-item ${type}`} onClick={onClick}>
            {type === 'simple' ? (
                <Row className="mx-0">
                    <Col className="px-0" sm={1} xs={2}>
                        <Avatar type="logo" name={name} url={logo} borderWidth={1} isSponsored={isSponsored} borderColor="#dee2e6" />
                    </Col>
                    <Col className="px-0" sm={8} xs={10}>
                        <p className="dsl-b14 mb-1">{name}</p>
                        <p className="dsl-b12 mb-0">{`${recommend.toString().slice(0, 2) || 0}% Recommended  ${ratingCount} Ratings`}</p>
                    </Col>
                    <Col className="px-0 d-flex ai-center jc-end ssm-jc-start offset-sm-0 offset-2" sm={3} xs={10}>
                        <Rating score={rating} />
                    </Col>
                </Row>
            ) : (
                <Row className="mx-0">
                    <Col className="px-0" xs={3} md={2}>
                        <Avatar url={logo} name={name} type="logo" size="extraLarge" isSponsored={isSponsored} />
                    </Col>
                    <Col className="px-0" xs={7} md={8}>
                        <p className="dsl-b14 mb-3">{name}</p>
                        <div className="d-h-start mb-3">
                            <Rating score={rating} />
                            <p className="dsl-b12 mb-0">{`${recommend.toString().slice(0, 2) || 0}% Recommended  ${ratingCount} Ratings`}</p>
                        </div>
                        <p className="dsl-b14 truncate-two mb-2">{removeTags(description)}</p>
                    </Col>
                    <Col className="px-0 d-flex flex-column jc-between" xs={2}>
                        <div className="mb-3">
                            <p className="dsl-p14 text-end mb-2">{companyName}</p>
                            <p className="dsl-b14 text-end mb-2">{phone && phone !== '' ? phone : 'Number not provided'}</p>
                        </div>
                        <div className="d-flex flex-column ai-end">
                            <Button type="link" name="RATE IT" />
                            <Button className="btn-company-contact" type="medium" name="SPECIAL QUOTE" />
                        </div>
                    </Col>
                </Row>
            )}
        </div>
    );
};

ProductItem.propTypes = {
    name: PropTypes.string,
    description: PropTypes.string,
    companyName: PropTypes.string,
    recommend: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    rating: PropTypes.number,
    ratingCount: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    phone: PropTypes.string,
    type: PropTypes.oneOf(['simple', 'detail']),
    url: PropTypes.string,
    onClick: PropTypes.func,
};

ProductItem.defaultProps = {
    name: '',
    description: '',
    companyName: '',
    recommend: '',
    rating: 0,
    ratingCount: '',
    phone: '',
    type: 'simple',
    url: null,
    onClick: () => {},
};

export default memo(ProductItem);
